import "babel-polyfill";
import "bootstrap-sass";

import Immutable from "immutable";
import moment from "moment-timezone";
import Raven from "raven-js";
import React from "react";
import {render} from "react-dom";
import {
  applyRouterMiddleware,
  browserHistory,
  IndexRoute,
  Redirect,
  Router,
  Route,
} from "react-router";
import {useScroll} from "react-router-scroll";

import {DATE_FORMAT_ISO} from "config/constants";
import settings from "config/settings";

import {trackPage} from "metrics";

import V2AppContainer from "v2/containers/AppContainer";
import V2AddDestinationPage from "v2/pages/AddDestinationPage";
import V2AddRoutePage from "v2/pages/AddRoutePage";
import V2CalendarPage from "v2/pages/CalendarPage";
import V2DatePage from "v2/pages/DatePage";
import V2DeleteDestinationPage from "v2/pages/DeleteDestinationPage";
import V2DeleteRoutePage from "v2/pages/DeleteRoutePage";
import V2DestinationPage from "v2/pages/DestinationPage";
import V2DuplicateDestinationPage from "v2/pages/DuplicateDestinationPage";
import V2EditDestinationPage from "v2/pages/EditDestinationPage";
import V2EditRoutePage from "v2/pages/EditRoutePage";
import V2MoveDestinationPage from "v2/pages/MoveDestinationPage";
import V2NotFoundPage from "v2/pages/NotFoundPage";
import V2ReassignRestPage from "v2/pages/ReassignRestPage";
import V2RoutePage from "v2/pages/RoutePage";
import V2SendHelpPage from "v2/pages/SendHelpPage";

// Setup moment with default TZ (PST) and locale (first day of week is Monday)
moment.tz.setDefault(settings.TIME_ZONE);
moment.updateLocale("en", {
  "week": {
    "dow": 1,
  },
});

// Setup Raven (Sentry)
if (process.env.SENTRY_DSN && process.env.SENTRY_RELEASE) {
  Raven.config(process.env.SENTRY_DSN, {
    release: process.env.SENTRY_RELEASE,
  }).install();
}

// Setup Immutable dev tools
if (settings.LEVEL === "development") {
  const installDevTools = require("immutable-devtools");
  installDevTools(Immutable);
}

const STYLES = {
  v2: [
    require("./styles/v2/app-coordinator.scss"),
  ],
};

const applyStyles = (toUse) => {
  STYLES[toUse].forEach(item => item.use());
};

render(
  <Router
    history={browserHistory}
    onUpdate={() => trackPage()}
    render={applyRouterMiddleware(useScroll())}>

    <Route
      onEnter={({location}, replace) => replace(location.pathname.replace("/v2/", "/"))}
      path="v2/**" />

    <Route
      component={V2AppContainer}
      onEnter={() => applyStyles("v2")}
      path="/">
      <IndexRoute
        onEnter={(nextState, replace) => replace(`/${moment().format(DATE_FORMAT_ISO)}`)} />

      <Redirect from="routes/" to="" />
      <Redirect from="routes/:date/" to=":date" />
      <Redirect from="routes/:date/:routeId/" to=":date/:routeId" />
      <Redirect from="routes/:date/:routeId/:id/" to=":date/:routeId/:id" />

      <Route component={V2DatePage} path=":date">
        <Route component={V2CalendarPage} path="calendar" />
        <Route component={V2AddRoutePage} path="new" />
        <Route component={V2RoutePage} path=":routeId">
          <Route component={V2DeleteRoutePage} path="delete" />
          <Route component={V2EditRoutePage} path="edit" />
          <Route component={V2AddDestinationPage} path="new" />

          <Route component={V2DestinationPage} path=":id" />
          <Route component={V2DeleteDestinationPage} path=":id/delete" />
          <Route component={V2DuplicateDestinationPage} path=":id/duplicate" />
          <Route component={V2EditDestinationPage} path=":id/edit" />
          <Route component={V2SendHelpPage} path=":id/help" />
          <Route component={V2MoveDestinationPage} path=":id/move" />
          <Route component={V2ReassignRestPage} path=":id/rest" />
        </Route>
      </Route>

      <Route component={V2NotFoundPage} path="**" />
    </Route>
  </Router>,
  document.getElementById("app")
);



/** WEBPACK FOOTER **
 ** ./src/app.js
 **/